// GeoJSON helpers for AOI export.

export function aoisToFeatureCollection(aois) {
  return {
    type: "FeatureCollection",
    features: aois.map((a, i) => ({
      type: "Feature",
      properties: {
        id: i + 1,
        mode: a.mode,
        area_km2: Math.round((a.area_km2 || 0) * 100) / 100,
        preset: a.presetName || null,
      },
      geometry: {
        type: "Polygon",
        coordinates: [a.coords],
      },
    })),
  };
}

export function downloadGeoJSON(aois, filename = "arjuna-aois.geojson") {
  const fc = aoisToFeatureCollection(aois);
  const blob = new Blob([JSON.stringify(fc, null, 2)], {
    type: "application/geo+json",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
